import { render, staticRenderFns } from "./TenantsList.vue?vue&type=template&id=680c59fe&scoped=true"
import script from "./TenantsList.vue?vue&type=script&lang=js"
export * from "./TenantsList.vue?vue&type=script&lang=js"
import style0 from "./TenantsList.vue?vue&type=style&index=0&id=680c59fe&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c59fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCardTitle,VDataTable,VFlex,VProgressLinear})
